
export default unpronoun;

function unpronoun(verb) {
  let unpronouned = verb.replace(/(me|te|se|nos|os|los|les|las|la|lo|le|melo|telo|selo|melos|telos|selos|mela|tela|sela|melas|telas|selas|seme|sete|sele|senos|seos)$/, '')
  if (verb != unpronouned) {
    return deaccentuate(unpronouned) // This is not technically correct but just happens to work okay the vast majority of the time.
  } else {
    return null
  }
}

function deaccentuate(verb) {
  return verb
    .replace(/á/, 'a')
    .replace(/é/, 'e')
    .replace(/í/, 'i')
    .replace(/ó/, 'o')
    .replace(/ú/, 'u')
}
